import { SkeletonText, Text } from "@chakra-ui/react";
import { useContext } from "react";

import parse from "html-react-parser";

import { ContributionContext } from "../context";

export function Description() {
  const { cardDescription, isLoaded, showDescription, descriptionId } =
    useContext(ContributionContext);

  if (!showDescription) return null;

  if (!isLoaded) {
    return (
      <SkeletonText
        mt={2}
        noOfLines={2}
        isLoaded={isLoaded}
        skeletonHeight={1.5}
      />
    );
  }

  return (
    <Text
      fontSize="md"
      noOfLines={3}
      lineHeight={6}
      whiteSpace="pre-wrap"
      data-testid="card-descriptionText"
      id={descriptionId}
    >
      {parse(cardDescription)}
    </Text>
  );
}
